<template>
  	<div id="home" class="default-layout">

		<header>
			<nav id="navbar">
				<div class="nav">
					<router-link to="/" class="nav-item">Back</router-link>
					<!-- <router-link to="/home" class="nav-item">Home</router-link> -->
				</div>
				<div class="logo">
					<img src="@/assets/images/navbar-logo.svg" alt=""/>
				</div>
			</nav>
		</header>
    
		<main>
			<section id="hero">
				<h1 class="display-1">Welcome,</h1>

				<h3>Offering an unrivaled customer experience will allow you to attract new customers more easily.</h3>

				<div class="main-hero-video">
					<img src="@/assets/images/sensor-details-thumbnail.png" alt="Overview Video" @click="showModal('sensor-details')">
				</div>

				<div class="secondary-hero-videos">
					<img src="@/assets/images/easy-setup-thumbnail.png" alt="Easy Setup Video" @click="showModal('easy-setup')">
					<img src="@/assets/images/how-it-works-thumbnail.png" alt="How it works Video" @click="showModal('how-it-works')">
				</div>
			</section>

			<section class="feature-callout">
				<div class="col">
					<h2>SmartAC.com <br/> partnership</h2>
					<p>Grow and retain more HVAC customers by partnering with us.</p>
					<router-link to="/partnership" class="button is-primary uppercase is-large">Learn more</router-link>
				</div>
				<div class="col">
					<img src="@/assets/images/handshake.jpg" alt=""/>
				</div>
			</section>

			<section class="feature-callout">
				<div class="col">
					<h2>In-home <br/> presentation</h2>
					<p>Example of how you can sell to your current customers.</p>
					<router-link to="/homeowner-benefits" class="button is-primary uppercase is-large">Learn more</router-link>
				</div>
				<div class="col">
					<img src="@/assets/images/woman-couch-tablet.jpg" alt=""/>
				</div>
			</section>
		</main>

		<Footer/>
		
		<VideoModal 
			v-show="isSensorDetailsVideoVisible" 
			@close="closeModal" 
			:videoSource="require('@/assets/videos/sensor-details.mp4')" 
			:modalTitle="'Sensor Details'" 
			:posterImage="require('@/assets/images/sensor-details-poster.jpg')"/>
		<VideoModal 
			v-show="isHowItWorksVideoVisible" 
			@close="closeModal" 
			:videoSource="require('@/assets/videos/how-it-works.mp4')" 
			:modalTitle="'How it Works'" 
			:posterImage="require('@/assets/images/how-it-works-poster.jpg')"/>
		<VideoModal 
			v-show="isEasySetupVisible" 
			@close="closeModal" 
			:videoSource="require('@/assets/videos/easy-setup.mp4')" 
			:modalTitle="'Easy Setup'" 
			:posterImage="require('@/assets/images/easy-setup-poster.jpg')"/>
  	</div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import VideoModal from '@/components/VideoModal.vue';

export default {
	components: {
		Footer,
		VideoModal
	},
	data () {
		return {
			isSensorDetailsVideoVisible: false,
			isHowItWorksVideoVisible: false,
			isEasySetupVisible: false,
		};
	},
	methods: {
		showModal(videoTitle) {
			if (videoTitle === 'sensor-details') {this.isSensorDetailsVideoVisible = true;}
			if (videoTitle === 'how-it-works') {this.isHowItWorksVideoVisible = true}
			if (videoTitle === 'easy-setup') {this.isEasySetupVisible = true}
		},
		closeModal() {
			this.isSensorDetailsVideoVisible = false;
			this.isHowItWorksVideoVisible = false;
			this.isEasySetupVisible = false;
		}
	}
}
</script>

<style lang="scss" scoped>
    #home {
        background-image: url('~@/assets/images/sensor-group-background.png');
        background-position: top left;
        background-repeat: no-repeat;
        background-size: auto;
    }

	.secondary-hero-videos {
		display: flex;
		align-items: flex-start;
		& img {
			flex: 0 1 auto;
			width: 50%;
			height: auto;
		}
	}
</style>